import { AgendaItem, AgendaItemType } from 'mini-agenda';

/**
 * This function determines if an item skips upcoming and ongoing marker treatment
 * An item is skipped if it does not have the following properties
 * 1. It is a non-null item
 * 2. It is of type event
 * 3. It has a non-null event
 * 4. It is not an effectively all day event
 * 5. It is not a cancelled event
 * 6. It is not a part of a series which has been cancelled
 * 7. It has read permissions
 * @param item
 */
export default function skipItemFromUpcomingOngoingTreatment(item: AgendaItem): boolean {
    return !(
        item &&
        item.type === AgendaItemType.Event &&
        item.event &&
        !item.event.IsEffectiveAllDayEvent &&
        !item.event.IsCancelled &&
        !item.event.IsSeriesCancelled &&
        !!(item.event.EffectiveRights && item.event.EffectiveRights.Read)
    );
}
